export var BATCH_EVENTS_URL = "api/v2/events";
export var BATCH_PETE_EVENTS_URL = "api/client-events";
export var instanceOfPeteEvent = function(object) {
    return "event_key" in object && "event_id" in object && "client_created_at" in object;
};
export var instanceOfDeprecatedEvent = function(object) {
    return "path" in object && "client_created_at" in object;
};
